import FormattedMessage from 'I18n/components/FormattedMessage';
import { FieldsetContextConsumer } from 'foundations-components/transitional/context';
import { View } from 'foundations-components/transitional/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BrowserFooter = ({
  disabled,
  onCancel,
  onConfirm
}) => {
  return /*#__PURE__*/_jsx(FieldsetContextConsumer, {
    children: ({
      size: fieldSize
    }) => {
      return /*#__PURE__*/_jsxs(View, {
        marginBlockStart: "500",
        children: [/*#__PURE__*/_jsx(Button, {
          "data-test-id": "insert-token-confirm-button",
          use: "tertiary",
          onClick: onConfirm,
          disabled: !!disabled,
          size: fieldSize,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "data-token-picker.confirm"
          })
        }), /*#__PURE__*/_jsx(Button, {
          marginInlineStart: "300",
          "data-test-id": "insert-token-cancel-button",
          use: "transparent",
          onClick: onCancel,
          size: fieldSize,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "data-token-picker.cancel"
          })
        })]
      });
    }
  });
};
BrowserFooter.displayName = 'BrowserFooter';
export default BrowserFooter;